module.exports = fox._r("fonts/iconfont.svg?ldnvmv", __webpack_public_path__ + "fonts/iconfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/iconfont.svg?ldnvmv
// module id = 950
// module chunks = 4